(() => {
  const ITEM = '.custom-ingredients__item--collapsible';
  const TRIGGER = '.custom-ingredients__summary';
  const PANEL = '.custom-ingredients__panel';

  const setOpen = (item, open) => {
    const trigger = item.querySelector(TRIGGER);
    const panel = item.querySelector(PANEL);
    item.classList.toggle('is-open', open);
    trigger?.setAttribute('aria-expanded', String(open));
    panel?.setAttribute('aria-hidden', String(!open));
  };

  const init = (root = document) => {
    root.querySelectorAll(ITEM).forEach((item) => {
      if (item.dataset.ingredientsReady === 'true') return;
      item.dataset.ingredientsReady = 'true';

      const trigger = item.querySelector(TRIGGER);
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        setOpen(item, !item.classList.contains('is-open'));
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
